import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ManualApprovalHeader } from '../../../models/manual-approval-header.model';
import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { utils } from '../../../helper/utils';
@Component({
  selector: 'app-approval-my-wo-grid',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './approval-my-wo-grid.component.html',
  styleUrl: './approval-my-wo-grid.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApprovalMyWoGridComponent {
  @Input() data: ManualApprovalHeader[] | [] | undefined;
  sort: string | undefined;
  urlNavigate: string | undefined;
  columns: Array<TableColumn> = [
    {
      id: 'priorityFlag',
      label: '',
      sortDisabled: true,
    },
    {
      id: 'maintenanceOrderNumber',
      label: 'Work Order Number',
      sortDisabled: true,
    },
    {
      id: 'equipmentNumber',
      label: 'Equipment Number',
      sortDisabled: true,
    },
    {
      id: 'totalOrderCostUSD',
      label: 'Total Value(USD)',
      sortDisabled: true,
      dataType: {
        type: 'number',
        formatter: (value, row) => {
          return utils.numberFormatter.format(Number(value));
        },
      },
    },
    {
      id: 'totalOrderCost',
      label: 'Total Value(Shop Currency)',
      sortDisabled: true,
      dataType: {
        type: 'number',
        formatter: (value, row) => {
          return `${(row.original as ManualApprovalHeader).isoCurrencyCode} ${utils.numberFormatter.format(Number(value))}`;
        },
      },
    },
    {
      id: 'maintenanceRepairModeCode',
      label: 'Mode',
      sortDisabled: true,
    },
    {
      id: 'maintenanceOrderStatusName',
      label: 'Status',
      sortDisabled: true,
    },
    {
      id: 'maintenanceOrderStatusDuration',
      label: 'Status Duration',
      sortDisabled: true,
      dataType: {
        type: 'string',
        formatter: (cellValue: unknown) => utils.formatDuration(cellValue as number),
      },
    },
    {
      id: 'createTimestamp',
      label: 'Created On',
      sortDisabled: true,
      dataType: {
        type: 'string',
        formatter: (value) => {
          const date = new Date(value as string);
          return `${utils.dateFormatter.format(date)}`;
        },
      },
    },
    {
      id: 'createUserID',
      label: 'Created By',
      sortDisabled: true,
    },
    {
      id: 'maintenanceShopCode',
      label: 'Shop ID',
      sortDisabled: true,
    },
    {
      id: 'locationCode',
      label: 'Location',
      sortDisabled: true,
    },
  ];

  ngOnInit() {
    this.urlNavigate = '/approvals/my-workorders';
  }
  onSortDirectionChange(event: Event) {
    let customEvent = event as CustomEvent;
    let sortColumn: string = this.sortColumnName(customEvent.detail.column);
    let sortDirection: string = customEvent.detail.direction == 'ascending' ? 'asc' : 'desc';
    if (sortColumn != 'id') {
      this.sort = `${sortColumn}:${sortDirection}`;
    }
  }
  private sortColumnName(gridColumnName: string): string {
    switch (gridColumnName) {
      case 'maintenanceOrderStatusDuration':
        return 'maintenanceOrderStatusUpdatedTimestamp';
      case 'totalOrderCostUSD':
        return 'totalOrderCost';
      default:
        return gridColumnName;
    }
  }
}
